import * as jose from 'jose';
const DEFAULT_MAX_AGE = 30 * 24 * 60 * 60
export async function createCompactJWT(payload, key) {

    const secret = new TextEncoder().encode(
        key
    )
    const jwt = await new jose.SignJWT(payload).setProtectedHeader({ alg: 'HS256' })
        .setIssuedAt()
        .setIssuer('urn:eidr:issuer')
        .setAudience('urn:eidr:audience')
        .setExpirationTime('30d')
        .sign(secret);
    return jwt;
}

export async function verifyCompactJWT(jwt, key) {
    const secret = new TextEncoder().encode(
        key
    )
    try {
        const {payload, protectedHeader} = await jose.jwtVerify(jwt, secret,
            {
                issuer: 'urn:eidr:issuer',
                audience: 'urn:eidr:audience',
            });

        return {payload, protectedHeader};
    } catch (error) {
        console.error('JWT verification failed:', error);
        return null;
    }
}